<template>
  <div>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Legal &amp; Admin Policies</h2>
              <p class="listing-page-desc">Insurance Bazaar</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')"/>
          </div>
        </div>
      </div>

      <div class="container article-box">
        <nav>
          <!-- nav nav-tabs   -->
          <div class="nav nav-tabs ib-acq-navtab" id="nav-tab" role="tablist">
            <a class="nav-item nav-link acq-nav-btn active" id="nav-policy-tab" data-toggle="tab" href="#nav-policy" role="tab" aria-controls="nav-policy" aria-selected="true">Privacy Policy</a>
            <a class="nav-item nav-link acq-nav-btn" id="terms-tab" data-toggle="tab" href="#nav-terms" role="tab" aria-controls="nav-terms" aria-selected="false">Terms of Use</a>
            <a class="nav-item nav-link acq-nav-btn" id="nav-faq-tab" data-toggle="tab" href="#nav-faq" role="tab" aria-controls="nav-faq" aria-selected="false">FAQs</a>
            <a class="nav-item nav-link acq-nav-btn" id="nav-delivery-tab" data-toggle="tab" href="#nav-delivery" role="tab" aria-controls="nav-delivery" aria-selected="false">Delivery Policy</a>
            <a class="nav-item nav-link acq-nav-btn" id="nav-refund-tab" data-toggle="tab" href="#nav-refund" role="tab" aria-controls="nav-refund" aria-selected="false">Cancellation &amp; Refund Policy</a>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-policy" role="tabpanel" aria-labelledby="nav-policy-tab">
            <div class="container py- py-md-4 py-xl-5">
              <div class="legal-box-title">Privacy <span>Policy</span></div>
              <div class="row">
                <div class="col-12">
                  <p>Insurancebazaar.com.pk also hereby known as “we”, “us” “they” “our” or “Insurance Bazaar” or “Insurance Bazaar (Private) Limited” has developed
                  this privacy policy (“Privacy Policy”) to explain how we collect, use, and disclose information about you to the Insurers when you use the Portal
                  and the services rendered by us through the Portal.</p>

                  <p>All visitors/users (“Customer”/ “Customers”, “Users” / “User”, “You “or “Your”)  of the Portal are advised to read and understand our Privacy
                  Policy carefully, as by accessing the Portal, you agree to be bound by the terms and conditions of this Privacy Policy and consent to the collection,
                  storage and use of information relating to you as provided herein.</p>

                  <p>By using this Portal, you consent to allowing us to collect and use your personal information as described in this Privacy Policy. By using the
                  portal, you agree to the contents of this Privacy Policy and give your irrevocable consent to us for collecting your personal information.</p>

                  <p>Our Privacy Policy explains:</p>

                  <ul>
                  <li>What information we collect and why we collect it.</li>
                  <li>How we use that information.</li>
                  <li>The choices we offer, including how to access and update information.</li>
                  </ul>

                  <p>We have tried to keep it as simple as possible, but if you’re not familiar with terms like cookies, IP addresses, pixel tags and browsers, then kindly
                  understand these key terms first. Your privacy matters to us so please do take the time to get to know our practices – and if you have, any questions
                  feel free to contact us by sending an email to <a href="mailto:info@insurancebazaar.com.pk">info@insurancebazaar.com.pk</a></p>

                  <p><b>A. COLLECTION OF INFORMATION</b></p>

                  <p>To provide the best experience to you, we collect and store personal information provided by you from time to time on the Portal. When you contact us,
                  we keep a record of your communication to help solve any issues you might be facing.The personal information that we may collect about you broadly falls
                  into the following categories:</p>

                  <p style="text-decoration: underline;"><b>Information you provide to us</b></p>

                  <p>When you register on our Portal:</p>

                  <ul>
                  <li>if you are an individual, you will be asked to provide certain contact information that is necessary for the registering for a Portal account,
                      including name, address, phone number, email address, job title and department;</li>
                  <li>if you are a company, you will be asked to provide certain identity information, tax registration and/or related information about your business,
                      such as your company name, business type and industry, corporate registration details and information about your business license;</li>
                  <li>we will also ask you to provide details or preferences about the Insurance Products or Policies that you may be interested in buying via the
                      Portal and any details or preferences relevant to your purchases;</li>
                  <li>in connection with the facilitation of transactions, purchases and payments over the Portal, you will be asked to provide certain payment
                      information. This may include bank account numbers, billing and delivery information, credit/debit card numbers, expiration dates and security code and
                      tracking information from cheques or money orders to facilitate the rendering of services to you.</li>
                  <li>we will process any information provided to us in connection with facilitating your claims and complaints in connection with the Portal or an Insurance
                      Product or Policy of an Insurer purchased via the Portal. Please note, Users may submit complaints regarding the services or an Insurance Product or Policy
                      on the Portal and/or disputes between the Insurers and the Customers to the Portal and under such circumstances, we will process data provided to us by the
                      Customers that is relevant to the disputes or complaints submitted.</li>
                  </ul>

                  <p style="text-decoration: underline;"><b>Information that we collect automatically</b></p>

                  <ul>
                  <li>If you contact us via our customer services department i.e. chat service, telephone or email, we may record a copy of your correspondence and may ask for
                      additional information to verify your identity.</li>
                  <li>We may collect contact details and other information of Users from publicly available sources for the purposes of verifying the Users and performing due
                      diligence on the Users.</li>
                  <li>We may collect details of the User activities, transactions and interactions on the Portal including information relating to the types and specifications
                      of the Insurance Policies and Products purchased, pricing information, claims and complaint records, communications between Insurers and Users and any
                      information disclosed in any discussion forum.</li>
                  <li>From time to time, we may also collect information, including contact names, addresses, phone numbers, fax numbers and email addresses, about the prospective
                      Users, during or in connection with marketing of Insurance Products or Policies through our Portal or other means.</li>
                  <li>If you visit our Portal, we will automatically collect certain information from your device. Specifically this information may include IP addresses,
                      device type, unique device identification numbers, browser type, broad geographic location (e.g. country or city-level location), browsing patterns and details
                      of how you have interacted with our Portal and the services available on it. In addition, we gather statistical information about the Portal and visitors to the
                      Portal including, browser software, operating system, software and hardware attributes, pages viewed, and number of sessions. Collecting this information enables
                      us to better understand the visitors who come to our Portal, where they come from, and what content is of interest to them.  We use this information for our
                      internal analytics purposes and to improve the quality and standard of our Portal. Some of this information may be collected using cookies and similar tracking
                      technology, as explained further under the section D “COOKIES” below.</li>
                  <li>We may receive personal information about you from third parties that are engaged by us to assist with providing services. This may include your name, email address,
                      company details and contact information.</li>
                  </ul>

                  <p><b>B. DISCLOSURE OR SHARING OF PERSONAL INFORMATION</b></p>

                  <p>We may disclose (or provide access to) personal information to the following categories of recipients:</p>

                  <ul>
                  <li>
                      third party business partners, service providers and/or affiliates of Insurancebazaar.com.pk engaged by us or working with us to assist us to provide services to
                      you or who otherwise process personal information for purposes described in this Privacy Policy or notified to you when we collect your personal information.
                      Categories of these partners or service providers include:
                      <ol class="custom-number">
                      <li>members of Insurance Bazaar and their respective affiliates and/or their designated service providers that work with us to provide processing services such
                          as software, tools, systems and messaging services for purposes described in this Privacy Policy;</li>
                      <li>marketing and advertising Portals, such as Google, Twitter, Facebook and Instagram, and providers of analytics services relating to users’ behavior, in order to
                          tailor the content you see when visiting our Portal. These Portals may combine information they collect on our Portal with data on their Portals and data they
                          collect from other websites or through other sources in order to conduct targeted advertising.  The processing activities of these third party marketing Portals
                          are governed by their own privacy policies, not this Privacy Policy;</li>
                      <li>cloud computing service providers to provide cloud storage services;</li>
                      <li>customer service providers to provide after-sale services;</li>
                      <li>risk control service providers to assess the security of Users’ accounts and transaction risks; and</li>
                      <li>third party rating / reviewing service providers to carry out reviews of our Services with customers if you choose to participate in reviewing or rating our
                          Services;</li>
                      </ol>
                  </li>
                  <li>to our professional advisers, law enforcement agencies, insurers, government and regulatory and other organizations where we believe it is necessary to comply
                      with applicable laws or to exercise, establish or defend our legal rights or protect your vital interests or those of any other person, we may also disclose and transfer
                      your personal information or as otherwise required or permitted by applicable laws.</li>
                  <li>to an actual or potential buyer (its agents or advisers) in connection with any actual or proposed purchase, merger or acquisition of any part of our business,
                      provided that we inform the buyer it must use your personal information only for the purposes disclosed in this Privacy Policy.</li>
                  <li>to the participating Insurers and agents and such other individuals and entities as deemed necessary. </li>
                  <li>to any other person with your consent to the disclosure.</li>
                  <li>we may provide aggregated or anonymized data to third parties, but when we do so, the information we share is in a de-identified format that does not personally
                      identify you.</li>
                  </ul>

                  <p><b>C. RETENTION</b></p>

                  <p>We may retain your personal information as long as we have an ongoing legitimate business need to do so, for example, to provide services to you, or as required or
                  permitted by applicable laws, such as tax and accounting laws.</p>

                  <p>When we have no ongoing legitimate business need to process your personal information, we may either delete or anonymize it or, if this is not possible (for example,
                  because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing
                  until deletion is possible. </p>

                  <p><b>D. COOKIES</b></p>

                  <p>This section explains how we use cookies and similar technologies (we'll refer to them collectively as "cookies") to recognize you when you visit our Portal.</p>

                  <p style="text-decoration: underline;"><b>Why we use cookies?</b></p>

                  <p>We use first and third party cookies for several reasons. Some cookies are required for technical and/or security reasons in order for our Portal to operate.
                  We refer to these as "essential" or "strictly necessary" cookies. First party cookies are mainly served to enable basic functionality on our Portal; including web
                  analytics cookies that help us understand how Users use our web pages and how we can improve their use.</p>

                  <p>In addition we also use social media cookies. You may register for Portal membership and "share" Portal content through social media such as Facebook and Twitter.
                  These websites have their own privacy policies which govern their use of information, which you can find on the respective websites.</p>

                  <p>We also use cookies to enable us to track and target the interests of Portal visitors to enhance the experience on our Portal by researching visiting patterns and
                  conduct interest-based advertising; assisting our partners to track user visits to the Portals; and to track progress and participation in promotions. We use first
                  and third party cookies for these purposes.</p>

                  <p><b>E. CHANGES TO THIS PRIVACY POLICY</b></p>

                  <p>We may update this Privacy Policy from time to time in response to changing legal, technical or business developments. When we update our Privacy Policy, we will take
                  appropriate measures to inform you, consistent with the significance of the changes we make. We will obtain your consent to any material Privacy Policy changes if and
                  when this is required by applicable data protection laws.</p>

                  <p>Any changes to this Privacy Policy will be posted by us on the Portal. Once posted on the Portal, the new Privacy Policy will be effective immediately.</p>

                  <p style="text-decoration: underline;"><b>Legal basis for data processing</b></p>

                  <p>We process personal information for the purposes set out in this Privacy Policy, as described above. Our legal basis for processing personal information will
                  depend on the personal information concerned and the specific context in which we collect it. However, we will normally collect and process personal information
                  about you only where it is:</p>

                  <ul>
                  <li>necessary for providing the services pursuant to the agreement between you and Insurancebazaar.com.pk and/or its affiliates (for example, to provide you with
                      the Services you request and to identify and authenticate you so you may use the Portal);</li>
                  <li>necessary to comply with legal requirements (for example, to comply with applicable accounting rules and to make mandatory disclosures to law enforcement);</li>
                  <li>necessary for our legitimate interests and not overridden by your rights; and/or</li>
                  <li>where it is based on your consent.</li>
                  </ul>

                  <p>If we collect and use your personal information in reliance on our legitimate, this interest will normally be to operate our Portal and services, manage our relationship
                  with you and communicate with you as necessary to provide our services to you and for our legitimate commercial interest, for instance, when responding to your queries,
                  improving our Portal and our services, undertaking marketing, or for the purposes of ensuring the security of our Portal and services and detecting or preventing illegal
                  activities such as fraud. We may have other legitimate interests and if appropriate we will make clear to you at the relevant time what those legitimate interests are.</p>
              </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-terms" role="tabpanel" aria-labelledby="nav-terms-tab">
            <div class="container py- py-md-4 py-xl-5">
              <div class="legal-box-title">Terms <span>of Use</span></div>
              <div class="row">
                <div class="col-12">
                  <p>Welcome to Insurancebazaar.com.pk also hereby known as “we”, “us” “they” “our” or “Insurance Bazaar” or “Insurance Bazaar (Private) Limited”. We run a website located
                  at Insurancebazaar.com.pk and other websites, domains, sub-domains, mobile applications and tools (collectively, the “Portal”). Through our Portal we operate as a
                  web-based corporate insurance agent (“Agent”) of various participating insurance companies (“Insurers”) bringing potential customers (“Customer”/ “Customers”,
                  “Users” / “User”, “You “or “Your”) of insurance policies and products (“Policy or Product”) to the Insurers, by displaying various Insurance Policies and Products
                  of Insurers setting out their pricing, coverage etc., for the Customer to compare and make a choice of purchasing a Product or Policy which best suits the Customer’s
                  needs and requirements (“Services”). All such purchases shall be made by the Customer directly from the Insurer and we take no responsibility of the accuracy or
                  reliability of the information displayed on our Portal and shall only assist the Customer in purchasing the Policies and Products of the Insurers.</p>

                  <p>Please read these terms and conditions (“Terms” / “User Agreement”), in its entirety, which govern your access and use of the Portal. These also contain important
                  information about your rights and obligations, as well as limitations and exclusions that apply to your use of our Portal.</p>

                  <p style="text-decoration: underline;"><b>A. CONDITIONS OF USE</b></p>

                  <p>By using the Portal, you hereby accept these Terms (including the linked information herein) and represent that you agree to comply with these Terms. This User
                  Agreement is deemed effective upon your use of the Portal which signifies your acceptance of these Terms. If you do not agree to be bound by this User Agreement
                  please do not access, register with or use this Portal.</p>

                  <p>Insurance Bazaar reserves the unfettered right to change, modify, add, or remove portions of these Terms at any time without any prior notification. Changes will
                  be effective when posted on the Portal with no other notice provided. Please keep yourself updated regarding these Terms by frequently visiting our Portal. Your
                  continued use of the Portal following the posting of changes to these Terms constitutes your acceptance of those changes.</p>

                  <p><b>1. Registration and User’s Account</b></p>

                  <p>In order for us to provide you with information regarding certain Insurance Products and Policies of Insurers, we require you provide us with certain information,
                  including your personal information, about yourself as part of the registration process to successfully make a User account (“Account”). Your action of successful
                  registration constitutes your acceptance of these Terms and the Privacy Policy of Insurance Bazaar. The data required for registration provided by the User must be
                  complete and accurate. The User is responsible for updating its/his/her own data that can be amended at any time from the respective interface of the Portal. We take
                  no responsibility over the use of the User Account and expressly disclaim any liability therefrom. Should a User suspect that any unauthorized party might be using
                  its/his/her account, he/she/it is under an obligation to notify us immediately, by emailing us at info@insurancebazaar.com.pk. By submitting the personal details at the
                  time of registration and pursuant to the use of the Portal, the User hereby affirmatively consents to our use of its/his/her personal details for contacting it/him/her
                  directly in order to provide /him/her the Services, including but not limited to occasionally sending notifications, text messages with promotional offers, service
                  updates and reaching out to the User to survey regarding the quality of the Portal. Notwithstanding anything contained herein, Insurance Bazaar at its sole discretion
                  reserves the right to restrict, suspend, or terminate the User’s Account if it is believed that the User is or may be in breach of this User Agreement or law or is
                  misusing the Services.</p>

                  <p>Upon registration on the Portal, Insurance Bazaar shall assign an account and issue a User ID and password (the latter shall be chosen by a User during registration)
                  to each User (“User ID”). Each User shall be solely responsible for maintaining the confidentiality and security of their User ID and for all activities that occur under
                  their Account. No User must share, assign, or permit the use of its/his/her User ID by another person outside of the User’s own business. Users agrees to notify
                  Insurance Bazaar immediately if they become aware of any unauthorized use of their password or account or any other breach of security of their Account.</p>

                  <p><b>2. User’s Responsibilities:</b></p>

                  <p>If you are purchasing any Insurance Policy or Product through our Portal, before purchasing it, you must read the terms and conditions of the relevant Insurer who’s
                  Insurance Policy or Product you are purchasing. This User Agreement only governs your use of the Portal and does not cover the terms and conditions of the Insurance
                  Policy or Product of the Insurer.</p>

                  <p>Once you provide us with all the necessary information as requested on the Portal through your User Account, based on such information, we will display Insurance
                  Policies with their pricing, coverage etc. we receive from participating Insurers. We take no responsibility of the accuracy and reliability of all information received
                  from the Users and from the Insurers as displayed on the Portal. Your decision to choose a particular Insurer’s Policy or Product shall be solely yours and shall not be
                  only based on the information displayed on the Portal. It is your responsibility to read and understand the Insurer’s Policy terms and conditions as provided by the
                  Insurer, before you purchase a Policy or Product.</p>

                  <p>Each User represents, warrants and agrees that:</p>

                  <ul>
                  <li>All information submitted by them to Insurance Bazaar whether during the registration process or thereafter shall be true, current, complete and accurate and shall promptly
                      update any change in the said information;</li>
                  <li>they have complete power and authority to accept these Terms and the terms and conditions of an Insurer regarding an Insurance Policy or Product they purchase, and have power
                      and authority to perform the obligations stated;</li>
                  <li>they consent to the inclusion of the information about them, whether personal or otherwise, in our User database and authorize Insurance Bazaar and our affiliates to share
                      such information with the Insurers or otherwise use their information in accordance with the Privacy Policy.</li>
                  </ul>

                  <p>Each User further represents, warrants and agrees that they shall:</p>

                  <ul>
                  <li>carry on their activities on the Portal in compliance with any applicable laws and regulations;</li>
                  <li>conduct their transactions through our Portal in good faith;</li>
                  <li>carry on their activities in accordance with the Terms and any applicable additional terms and conditions of Insurers;</li>
                  <li>not use the Services or Portal to defraud any person or entity (including without limitation sale of stolen items, use of stolen credit/debit cards);</li>
                  <li>not impersonate any person or entity, misrepresent themselves or their affiliation with any person or entity;</li>
                  <li>not engage in spamming or phishing;</li>
                  <li>not engage in any other unlawful activities (including without limitation those which would constitute a criminal offence, give rise to civil liability, etc.)
                      or encourage or abet any unlawful activities;</li>
                  <li>not involve in any attempts to copy, reproduce, exploit or expropriate Insurance Bazaar’s various proprietary directories, databases and listings;</li>
                  <li>not involve any computer viruses or other destructive or interruptive devices and codes that have the effect of damaging, interfering with, intercepting or
                      expropriating any software or hardware system, data or personal information;</li>
                  <li>not involve in any scheme to undermine the integrity of the data, systems or networks used by Insurance Bazaar and/or any User of the Portal or gain unauthorized
                      access to such data, systems or networks;</li>
                  <li>not engage in any activities that would otherwise create any liability for Insurance Bazaar or our affiliates.</li>
                  <li>not use the Services and User ID to engage themselves in activities which are identical or similar to Insurance Bazaar’s business model.</li>
                  </ul>

                  <p><b>3. Permission to Use the Site</b></p>

                  <p>Content provided on this Portal is solely for informational purposes. Insurance Products, Policies, and information including price, features, coverage and any other
                  details as expressed on this Portal are the responsibility of the Insurers displaying them and is not guaranteed as completely accurate by us. </p>

                  <p>We grant you a limited permission to access and make personal use of this Portal, but not to download or modify the Portal or any portion of it in any manner. This
                  permission to use and access the Portal does not include any resale or commercial use of this Portal or its contents; any collection and use of any Policy or Product
                  listings, descriptions, or prices; any derivative use of this Portal or its contents; any downloading or copying of account information for the benefit of another User
                  or a third party; or any use of data mining, robots, or similar data gathering and extraction tools.</p>

                  <p>This Portal or any portion of it (including but not limited to any copyrighted material, trademarks, or other proprietary information) may not be reproduced, duplicated,
                  copied, sold, resold, visited, distributed or otherwise exploited for any commercial purpose without express written consent by us as may be applicable.</p>

                  <p>You agree and undertake not to perform restricted activities listed within this section; undertaking these activities will result in an immediate cancellation of User Account,
                  Services, reviews, or any existing incomplete transactions and in severe cases may also result in legal action on:</p>

                  <ul>
                  <li>refusal to comply with the Terms described herein or any other guidelines and policies related to the use of the Portal as available on the Portal at all times;</li>
                  <li>impersonate any person or entity or to falsely state or otherwise misrepresent your affiliation with any person or entity;</li>
                  <li>use the Portal for illegal purposes;</li>
                  <li>attempt to gain unauthorized access to or otherwise interfere or disrupt other computer systems or networks connected to the Portal or Services;</li>
                  <li>interfere with another’s utilization and enjoyment of the Portal;</li>
                  <li>post, promote or transmit through the Portal any prohibited materials as deemed illegal by the Islamic Republic of Pakistan; and/or</li>
                  <li>use or upload, in any way, any software or material that contains, or which you have reason to suspect that contains, viruses, damaging components,
                      malicious code or harmful components which may impair or corrupt the Portal’s data or damage or interfere with the operation of another User’s computer
                      or mobile device or the Portal and use the Portal other than in conformance with the acceptable use policies of any connected computer networks, any applicable internet
                      standards and any other applicable laws.</li>
                  </ul>

                  <p>You agree not to undertake any action to undermine the integrity of the computer systems or networks of Insurance Bazaar and/or any other User nor to gain unauthorized access
                  to such computer systems or networks.</p>

                  <p><b>4. Breaches by Users</b></p>

                  <p>Without limiting the generality of the provisions of the Terms, a User would be considered as being in breach of the Terms in any of the following circumstances:</p>

                  <ul>
                  <li>upon complaint or claim from any Insurer, Insurance Bazaar has reasonable grounds to believe that such User has willfully or materially failed to perform their obligations
                      under their contract with such Insurer;</li>
                  <li>Insurance Bazaar has reasonable grounds to suspect that such User has used a stolen debit or credit card or other false or misleading information in any transaction with an
                      Insurer,</li>
                  <li>Insurance Bazaar has reasonable grounds to suspect that any information provided by the User is not current or complete or is untrue, inaccurate, or misleading, or</li>
                  <li>Insurance Bazaar believes that the User’s actions may cause financial loss or legal liability to Insurance Bazaar or their affiliates.</li>
                  </ul>

                  <p>Insurance Bazaar reserves the right to cooperate fully with governmental authorities, private investigators and/or injured third parties in the investigation of any
                  suspected criminal, cyber or civil wrongdoing.  Further, to the extent permitted by applicable laws and policies, Insurance Bazaar may disclose the User’s identity,
                  contact information and/or information regarding the User’s Account(s), transactions or activities carried out on or via the Portal, if requested by a government or
                  law enforcement body, an injured third party, or as a result of a or other legal action. Insurance Bazaar shall not be liable for damages or results arising from such
                  disclosure, and Users agree not to bring any action or claim against Insurance Bazaar for such disclosure.</p>

                  <p style="text-decoration: underline;"><b>B.	PURCHASES BY USERS</b></p>

                  <p>Through the Portal, Insurance Bazaar provides electronic web-based services for exchanging information between Insurers and Users for rendering of Services. However,
                  for any Services, Insurance Bazaar does not represent either the User or the Insurer in specific transactions regarding any Insurance Policies or Products purchased by
                  the Users. Insurance Bazaar does not control and is not liable to or responsible for the quality, safety, lawfulness or availability of the Insurance Products and Services
                  offered for sale on the Portal or the ability of the Insurers to complete a sale or the ability of Users to complete a purchase.</p>

                  <p>Each User acknowledges that it/he/she is fully assuming the risks of conducting any purchase and sale transactions in connection with using the Portal and Services,
                  and that it is fully assuming the risks of liability or harm of any kind in connection with subsequent activity of any kind relating to Insurance Products and Services
                  that are the subject of transactions using the Portal. Such risks shall include, but are not limited to, mis-representation of Insurance Products and Services, fraudulent
                  schemes, unsatisfactory quality, failure to meet specifications, unlawful products, cost mis-calculations, breach of warranty, and breach of contract. All of the risks
                  are hereafter referred to as "transaction risks". Each User agrees that Insurance Bazaar shall not be liable or responsible for any damages, claims, liabilities, costs,
                  harms, inconveniences, business disruptions or expenditures of any kind that may arise a result of or in connection with any transaction risks.</p>

                  <p>Users are solely responsible for all of the terms and conditions of the transactions conducted on, through or as a result of use of the Portal or Services.</p>

                  <p><b>1.	Conditions of purchase between the Users and Insurers</b></p>

                  <p>In case the User chooses to opt for an Insurance Product or Policy displayed on the Portal, the User, before purchasing any such Insurance Product or Policy, shall make sure that
                  he/she/it has read the terms and conditions of the relevant Insurance Product or Policy, as issued by an Insurer. Once the User has read the terms and conditions of an Insurance
                  Product or Policy, it may initiate the purchase process by clicking or tapping on “I AGREE” or “I ACCEPT” buttons, giving its irrevocable assent to such terms and shall be bound
                  to abide by such terms and making an offer to purchase the Insurer’s Policy or Product. No Insurance Product or Policy displayed on the Portal shall be deemed as an offer made by
                  Insurance Bazaar to sell the User any Insurance Product or Policy. When the Users submits their details and offer to purchase specific Insurance Product or Policy of an Insurer,
                  the acceptance by an Insurer is independent from the Insurance Bazaar and no such acceptance shall be deemed to be an acceptance by Insurance Bazaar. The offer and acceptance
                  stipulated in this section is independent of this User Agreement and depends solely on the terms and conditions of the Insurer. Once an offer is accepted by an Insurer, the
                  User shall be notified of such acceptance through the Portal or any such mode as determined by the Insurer. Without the evidence of offer and acceptance, no Insurance Policy or
                  Product sale shall be deemed to be completed and the insurance contract between the User and Insurer shall be considered null and void.</p>

                  <p><b>2.  Payments</b></p>

                  <p>All the prices or premiums or any other details of Insurance Products and Policy displayed on the Portal are provided independently by the Insurers and not by Insurance Bazaar.
                  All the payments of purchases made by Users with respect to a specific Insurance Product or Policy shall be made through a payment gateway present on our Portal. Such payments
                  shall be charged through your credit or debit cards provided by you while registering on our Portal. Other modes of payments include cheques, pay orders and bank transfer etc.</p>

                  <p><b>3. Documents</b></p>

                  <p>The Users may be asked to upload certain documents, when they avail any Services on our Portal and assent to buy an Insurance Product or Policy. All such documents shall be uploaded
                  as required to the User Account. All other documents in relation to the Insurance Policies and Products may be uploaded at the User Portal or may be made available to the respective
                  User by sending a hard copy of such documents as determined by us or the Insurer.</p>

                  <p><b>4. Insurance Products and Policies</b></p>

                  <p>All Insurance Products and Polices shall be governed by certain terms and conditions which the User is under an obligation to comply with. In case the offer made by a User is accepted
                  by an Insurer an underlying acceptance and relevant terms and conditions of an Insurer’s Insurance Product or Policy shall be shared by the Insurer to the User. The User shall be
                  obligated to read it carefully and familiarize itself/himself/herself with such terms of such Policy or Product. Such terms may include terms related to deductibles as to premiums,
                  limits of insurance cover, and other obligations that apply. In case there is an ambiguity to understand the terms of such policy, the Insurer may be contacted by the User for
                  clearance of thought and further guidance.</p>

                  <p>In case the User fails to read and comply with the Insurer’s terms and suffers loses in respect to its Insurance Product or Policy or any other loses, Insurance Bazaar disclaims
                  any liability arisen in such circumstances.</p>

                  <p>In the event that any User has a dispute with any Insurer to a transaction, such User agrees to release and indemnify Insurance Bazaar (and their agents, affiliates, directors,
                  officers and employees) from all claims, demands, actions, proceedings, costs, expenses and damages (including without limitation any actual, special, incidental or consequential
                  damages) arising out of or in connection with such transaction.</p>

                  <p style="text-decoration: underline;"><b>C.	REPRESENTATIONS AND WARRANTIES</b></p>

                  <p>We do not make or give any representation or warranty, respectively as to specifics (such as quality, value, salability, etc.) of any Insurance Product or Policy displayed or to
                  be sold or sold on the Portal. We accept no liability for any errors, omissions, or any actions whether on behalf of itself, our affiliates or the Insurer.</p>

                  <p>We are not responsible for any non-performance or breach by either party of any contract entered into between you and any Insurer. We cannot and do not guarantee your actions or those
                  of the Insurers as they conclude transactions on the Portal.</p>

                  <p>We do not at any point of time during any transaction as entered into by you with a third party on our Portal, gain title to or have any rights or claims over the Insurance Products or
                  Policies offered by an Insurer. Therefore, we do not have any obligations or liabilities in respect of such contract(s) entered into between you and any Insurer. We are also not
                  responsible for unsatisfactory or delayed performance by Insurers.</p>

                  <p style="text-decoration: underline;"><b>D.	DISCLAIMERS AND LIABILITIES</b></p>

                  <p>Please review our Privacy Policy, which also governs User’s visit to the Portal. The personal information / data provided to us by you or your use of our Portal will be treated as strictly
                  confidential, in accordance with the privacy agreement. If you object to your information being transferred or used in the manner specified in the privacy agreement, please do not
                  use the Portal.</p>

                  <p><b>1.	Site only for Communication</b></p>

                  <p>You agree, understand and acknowledge that the Portal enables you to purchase Insurance Products or Policies displayed at the price indicated therein at any time from any location using
                  a payment method as made available on the Portal. You further agree and acknowledge that we are only a facilitator and cannot be a party to or control in any manner any transactions on
                  the Portal or on a payment gateway as made available to you on the Portal. Accordingly, the contract of sale of Insurance Products and Policies on the Portal shall be a strictly bipartite
                  contract between you and the Insurers on our Portal.</p>

                  <p><b>2.	Continued Availability of the Site</b></p>

                  <p>We will do our utmost to ensure that access to the Site is consistently available and is uninterrupted and error-free. However, due to the nature of the internet and the nature of the Portal,
                  this cannot be guaranteed. Additionally, your access to the Portal may also be occasionally suspended or restricted to allow for repairs, maintenance, or the introduction of new facilities or
                  Services at any time without prior notice. We will attempt to limit the frequency and duration of any such suspension or restriction.</p>

                  <p><b>3.	Insurance Claims Handling</b></p>

                  <p>As we act only as corporate agents of various Insurers, we disclaim any liability with regards to any claims regarding the Insurance Products or Policies. We act only as facilitators between the
                  Users and Insurers, therefore, if any User has a claim regarding an Insurance Product, the same shall be communicated to the respective Insurer. The Insurer shall make the claim settlement directly
                  in the name of the User, its/his/her representative or guardian, as the case may be.</p>

                  <p><b>4.	Disclaimer of Liability</b></p>

                  <p>You acknowledge and undertake that you are accessing the Services on the Portal and transacting at your own risk and are using your best and prudent judgment before entering into any transactions
                  through the Portal. We shall neither be liable nor responsible for any actions or inactions of Insurers nor any breach of conditions, representations or warranties by the Insurers and hereby expressly
                  disclaim any and all responsibility and liability in that regard. We shall not mediate or resolve any dispute or disagreement between you and the Insurers.</p>

                  <p><b>5.	Limitation of Liability</b></p>

                  <p>You agree that neither Insurance Bazaar nor its employees, directors and personnel shall be liable for any direct, indirect, incidental, special, consequential or exemplary damages arising out of or in
                  connection with (i) your use of the Portal, (ii) the liability of any Insurer, and (iii) in connection with the Services availed through the Portal. You further agree that Insurance Bazaar shall not be
                  liable for any damages arising from interruption, suspension or termination of Services, including without limitation any direct, indirect, incidental, special, consequential or exemplary damages, whether
                  such interruption, suspension or termination was justified or not, negligent or intentional, inadvertent or advertent.</p>

                  <p><b>6.	Indemnity</b></p>

                  <p>You agree to defend, indemnify and hold harmless Insurance Bazaar and its officers, directors, employees, agents and affiliates (each, an “Indemnified Party”), from and against any losses, claims, actions,
                  costs, damages, penalties, fines and expenses, including without limitation attorneys' fees and expenses, that may be incurred by an Indemnified Party arising out of, relating to or resulting from your
                  unauthorized use of the Portal or from any breach by you of these Terms, including without limitation any actual or alleged violation of any federal, provincial or local statute, ordinance, administrative
                  order, rule or regulation. Insurance Bazaar shall provide notice to you promptly of any such claim, suit or proceeding and shall have the right to control the defense of such action, at your expense, in defending
                  any such claim, suit or proceeding. You agree that this clause shall survive termination of this agreement.</p>

                  <p style="text-decoration: underline;"><b>E.	TRADEMARKS AND COPYRIGHTS</b></p>

                  <p><b>Insurancebazaar.com.pk, Insurance Bazaar logo, Insurance Bazaar</b>, and other marks indicated on our Portal are trademarks or registered trademarks in the relevant jurisdiction(s). Our graphics, logos, page headers,
                  button icons, scripts and service names are the trademarks or trade dress and may not be used in connection with any service that does not belong to us or in any manner that is likely to cause confusion among Users,
                  or in any manner that disparages or discredits us. All other trademarks that appear on this Portal are the property of their respective owners, who may or may not be affiliated with, connected to, or sponsored by us.</p>

                  <p>All intellectual property rights, whether registered or unregistered, in the Portal, information content on the Portal and all the website design, including, but not limited to text, graphics, software, photos, video,
                  music, sound, and their selection and arrangement, and all software compilations, underlying source code and software shall remain our property. The entire contents of the Portal also are protected by copyright as a
                  collective work under Pakistani copyright laws and international conventions. All rights are reserved.</p>

                  <p>You may not, and will not encourage, assist or authorize any other person to copy, modify, reverse engineer, decompile or disassemble, or otherwise tamper with our Portal and its contents whether in whole or in part,
                  or create any derivative works from it.</p>

                  <p style="text-decoration: underline;"><b>F.	GENERAL PROVISIONS</b></p>

                  <p><b>1.	Communicating with Us</b></p>

                  <p>When you visit the Portal, or send e-mails to us, you are communicating with us electronically. You will be required to provide a valid phone number while placing an order with us. We may communicate with you by e-mail,
                  short messaging service, and phone call or by posting notices on the Portal or by any other mode of communication we choose to employ. For contractual purposes, you consent to receive communications (including transactional,
                  promotional and/or commercial messages), from us with respect to your use of the Portal (and/or placement of your order) and agree to treat all modes of communication with the same importance.</p>

                  <p><b>2.	Amendments</b></p>

                  <p>We reserve the right to make changes to the Portal, its policies, these Terms and any other publicly displayed condition or Service promised at any time. You will be subject to the policies and Terms in force at the time you
                  used the Portal unless any change to those policies or these Terms is required to be made by law or government authority.</p>

                  <p>Insurance Bazaar reserves the right, at its sole and absolute discretion, to change, modify, add to, supplement or delete any of the terms and conditions of these Terms, effective immediately without prior notice. Your continued
                  use of the Portal following any revision to these Terms shall constitute your complete and irrevocable acceptance of any and all such changes. Contact us if you have any comments or questions, please do not hesitate to reach out
                  to us at info@insurancebazaar.com.pk.</p>

                  <p><b>3.	Events Beyond Our Control</b></p>

                  <p>We will not be held responsible for any delay or failure to comply with our obligations under these conditions if the delay or failure arises from any cause or reason which is beyond our reasonable control.</p>

                  <p>Under no circumstances shall Insurance Bazaar be held liable for any delay or failure or disruption of the content or Services delivered through the Portal resulting directly or indirectly from acts of nature,
                  forces or causes beyond our reasonable control, including without limitation, internet failures, computer, telecommunications or any other equipment failures, electrical power failures, strikes, labor disputes,
                  riots, insurrections, civil disturbances, shortages of labor or materials, fires, flood, storms, explosions, acts of god, war, governmental actions, orders of domestic or foreign courts or tribunals or non-performance
                  of third parties.</p>

                  <p><b>4.	Termination</b></p>

                  <p>In an event of a breach by you of these Terms, in addition to any other legal or equitable remedies, we may, without prior notice to you, immediately revoke any or all of your rights granted under these Terms.
                  Upon such termination, you shall immediately cease all access to and use of the Portal and we shall, in addition to any other legal or equitable remedies, immediately revoke all password(s) and account identification
                  issued to you and deny your access to and use of this Portal in whole or in part. Any termination of this Agreement shall not affect the respective rights and obligations (including without limitation, payment obligations)
                  of the parties arising before the date of termination. You furthermore agree that the Insurance Bazaar shall not be liable to you or to any other person as a result of any such suspension or termination. If you are
                  dissatisfied with the Portal or with any terms, conditions, rules, policies, guidelines, or practices in operating the Portal, your sole and exclusive remedy is to discontinue using the Portal and its Services.</p>

                  <p><b>5.	Governing law and jurisdiction</b></p>

                  <p>These Terms are governed by the laws of Pakistan. The Pakistani courts in Lahore shall have the exclusive jurisdiction and venue over any dispute arising out of or relating to these Terms, and each party hereby consents
                  to the jurisdiction and venue of such courts. If any provision of these Terms is found to be invalid in any court having competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining
                  provisions of these Terms, which shall remain in full force and effect.</p>
              </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-faq" role="tabpanel" aria-labelledby="nav-faq-tab">
            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
              <div class="container py- py-md-4 py-xl-5">
                <div class="legal-box-title">F<span>AQs</span></div>
                <!-- First FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading active" role="tab" id="headingOne">
                    <div class="collapsible-link">
                      <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Q:- What is an insurance bazaar?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                    <div class="panel-body">
                      Insurance Bazaar is a marketplace for all your insurance needs; it provides a paperless journey between you and the insurance provider; you can perform all the steps of buying an insurance policy from the comfort of your home. You can file a claim and service your policy from within the app as well.
                    </div>
                  </div>
                </div>
                <!-- Second FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwo">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Q:- Why Should I use Insurance Bazaar?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                    <div class="panel-body">
                      Insurance Bazaar removes all the hassles for you whether it is buying a policy, requesting policy servicing or filing a claim. It also provides a comparison of the best available plans and coverages in Pakistan.
                    </div>
                  </div>
                </div>
                <!-- Third FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingThree">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        Q:- What types of Insurance do you offer on your application?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                    <div class="panel-body">
                      At the moment we are offering the following products from different companies
                      <ul>
                        <li>Life Insurance</li>
                        <li>Motor Insurance</li>
                        <li>Health Insurance</li>
                        <li>Travel</li>
                        <li>Personal Accident Insurance</li>
                        <li>Home Insurance</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- Fourth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingFour">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Q:- What are my payment options?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
                    <div class="panel-body">
                      Your payment options are credit card and debit card at the moment.
                    </div>
                  </div>
                </div>
                <!-- Fifth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingFifth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFifth" aria-expanded="false" aria-controls="collapseFifth">
                        Q:- How do I choose a policy that is right for me?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseFifth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFifth">
                    <div class="panel-body">
                      You can choose the policy that is right for you by comparing the different policies and reading the information provided in the accompanying brochures.
                    </div>
                  </div>
                </div>
                <!-- Sixth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingSixth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSixth" aria-expanded="false" aria-controls="collapseSixth">
                        Q:- What are insurance company ratings?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseSixth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSixth">
                    <div class="panel-body">
                      Insurance companies are rated by independent bodies on different parameters.
                    </div>
                  </div>
                </div>
                <!-- Seventh FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingSeventh">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSeventh" aria-expanded="false" aria-controls="collapseSeventh">
                        Q:- How do I cancel my policy?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseSeventh" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeventh">
                    <div class="panel-body">
                      You can request to cancel your policy from the policy servicing menu of the Insurance Bazaar APP.
                    </div>
                  </div>
                </div>
                <!-- Eigth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingEigth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseEigth" aria-expanded="false" aria-controls="collapseEigth">
                        Q:- My promo code doesn’t work?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseEigth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEigth">
                    <div class="panel-body">
                      Your promo may have already been used or may have been expired.
                    </div>
                  </div>
                </div>
                <!-- Ninth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingNinth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseNinth" aria-expanded="false" aria-controls="collapseNinth">
                        Q:- Why is my claim taking so long?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseNinth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingNinth">
                    <div class="panel-body">
                      Claims are processed by the insurance company and they have their own criteria for verifying and processing claims.
                    </div>
                  </div>
                </div>
                <!-- Tenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTenth" aria-expanded="false" aria-controls="collapseTenth">
                        Q:- Why was my policy rejected?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTenth">
                    <div class="panel-body">
                      Your policy may have been rejected due to a number of reasons the most prevalent of which is the upload of incorrect information, KYC failure etc.
                    </div>
                  </div>
                </div>
                <!-- Eleventh FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingEleventh">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseEleventh" aria-expanded="false" aria-controls="collapseEleventh">
                        Q:- What is verisys?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseEleventh" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEleventh">
                    <div class="panel-body">
                      Verisys is NADRA’s system of ID verification. The insurance company verifies customer ID before policy issuance.
                    </div>
                  </div>
                </div>
                <!-- Twelveth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwelveth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwelveth" aria-expanded="false" aria-controls="collapseTwelveth">
                        Q:- How will I make sure that you won’t misuse my signatures or CNIC?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwelveth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwelveth">
                    <div class="panel-body">
                      Your personal details are saved in an encrypted database, and when scanned your CNIC and signatures will be scanned it will be digitally watermarked.
                    </div>
                  </div>
                </div>
                <!-- Thirteenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingThirteenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThirteenth" aria-expanded="false" aria-controls="collapseThirteenth">
                        Q:- Why are my policy numbers different?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseThirteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThirteenth">
                    <div class="panel-body">
                      Each insurance company and Insurance product has its own format for the policy number.
                    </div>
                  </div>
                </div>
                <!-- Fourteenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingFourteenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFourteenth" aria-expanded="false" aria-controls="collapseFourteenth">
                        Q:- What is the need for uploading these images or document while claiming intimation?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseFourteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFourteenth">
                    <div class="panel-body">
                      These images or supporting documents help in expediting the claim process.
                    </div>
                  </div>
                </div>
                <!-- Fifteenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingFifteenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFifteenth" aria-expanded="false" aria-controls="collapseFifteenth">
                        Q:- What is a pre-policy document?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseFifteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFifteenth">
                    <div class="panel-body">
                      The pre-policy document is a confirmation that you have placed an order for the policy from Insurance Bazaar.
                    </div>
                  </div>
                </div>
                <!-- Sixteenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingSixteenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSixteenth" aria-expanded="false" aria-controls="collapseSixteenth">
                        Q:- What is an endorsement/policy servicing?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseSixteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSixteenth">
                    <div class="panel-body">
                      Any change in the insurance policy is called an endorsement.
                    </div>
                  </div>
                </div>
                <!-- Seventeenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingSeventeenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSeventeenth" aria-expanded="false" aria-controls="collapseSeventeenth">
                        Q:- How can I request policy servicing?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseSeventeenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeventeenth">
                    <div class="panel-body">
                      You can request policy servicing from the account menu of the Insurance Bazaar APP. Select your active policy, choose servicing type and enter the new details, Insurance company have the right to accept or reject your request.
                    </div>
                  </div>
                </div>
                <!-- Eigtheenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingEigtheenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseEigtheenth" aria-expanded="false" aria-controls="collapseEigtheenth">
                        Q:- The scanner isn’t identifying my card details.
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseEigtheenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingEigtheenth">
                    <div class="panel-body">
                      You can manually input the card details if your card isn’t auto scanned.
                    </div>
                  </div>
                </div>
                <!-- Nineteenth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingNineteenth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseNineteenth" aria-expanded="false" aria-controls="collapseNineteenth">
                        Q:- The scanner puts forth false details.
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseNineteenth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingNineteenth">
                    <div class="panel-body">
                      Please rectify the mistakes and then proceed.
                    </div>
                  </div>
                </div>
                <!-- Twentyth FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentyth">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyth" aria-expanded="false" aria-controls="collapseTwentyth">
                        Q:-	What are the perks of being a ‘founder member’?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentyth" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyth">
                    <div class="panel-body">
                      Being a founder member gets you perks such as the founder member badge; free accident and hospitalization cover for one year and a promo for 10% off your next purchase.
                    </div>
                  </div>
                </div>
                <!-- Twentyone FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentyone">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyone" aria-expanded="false" aria-controls="collapseTwentyone">
                        Q:- How do I file a claim?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentyone" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyone">
                    <div class="panel-body">
                      Filing a claim with an insurance bazaar is very easy; just go to claims, select policy and then file a claim with all the required documents and details.
                    </div>
                  </div>
                </div>
                <!-- Twentytwo FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentytwo">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentytwo" aria-expanded="false" aria-controls="collapseTwentytwo">
                        Q:- How long will my policy remain in effect?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentytwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentytwo">
                    <div class="panel-body">
                      Every policy has a different expiry date and it remains in effect till that expiry date.
                    </div>
                  </div>
                </div>
                <!-- Twentythree FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentythree">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentythree" aria-expanded="false" aria-controls="collapseTwentythree">
                        Q:- What is premium?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentythree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentythree">
                    <div class="panel-body">
                      It is the amount paid by the policy owner for the purchase of a life insurance policy. Subsequently, renewal premiums are paid by due dates or within the grace period to ensure that the policy remains in force and that the benefits available under the policy remain intact.
                    </div>
                  </div>
                </div>
                <!-- Twentyfour FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentyfour">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyfour" aria-expanded="false" aria-controls="collapseTwentyfour">
                        Q:- What is a policy document?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentyfour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyfour">
                    <div class="panel-body">
                      A policy document is printed and signed an insurance contract between the policy owner and insurance Bazaar. Policy documents consist of the policy schedule, stamp duty page, standard policy conditions and supplementary contracts (if provided for in the policy).
                    </div>
                  </div>
                </div>
                <!-- Twentyfive FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentyfive">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentyfive" aria-expanded="false" aria-controls="collapseTwentyfive">
                        Q:- What is a total loss?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentyfive" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentyfive">
                    <div class="panel-body">
                      If the insurance company deems that the cost of the repair of an accidental vehicle is more than 50% of the vehicle’s current market value, it is likely that such vehicle will be declared as Total Loss as it is uneconomical to get the vehicle repaired.
                    </div>
                  </div>
                </div>
                <!-- Twentysix FAQ -->
                <div class="panel panel-default">
                  <div class="panel-heading" role="tab" id="headingTwentysix">
                    <div class="collapsible-link">
                      <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwentysix" aria-expanded="false" aria-controls="collapseTwentysix">
                        Q:- Can the insurance provider cancel my policy?
                        <!-- <span class="Qmark">?</span> -->
                        <span class="plus-icon">&plus;</span>
                        <span class="minus-icon">&minus;</span>
                      </a>
                    </div>
                  </div>
                  <div id="collapseTwentysix" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwentysix">
                    <div class="panel-body">
                      Yes, the insurance company reserves right to cancel the policy at any time.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-delivery" role="tabpanel" aria-labelledby="nav-delivery-tab">
            <div class="panel-group" role="tablist" aria-multiselectable="true">
              <div class="container py- py-md-4 py-xl-5">
                <div class="legal-box-title">Delivery<span> &#47; Issuance of Insurance Policy</span></div>
                <p>Insurance Bazaar is providing its digital platforms to customers and Insurance companies and acts as a corporate agent. Your policy will be issued directly by the insurance company from which you bought the bought through our platform. Normally, Insurance companies take 1 to 2 working days for Policy Issuance subject to full premium payment, customer’s successful KYC, and successful pre-risk survey if required.</p>
                <p>Upon Policy Issuance, you will be notified through mobile notification and an email. You can also view your policies in policy listing sections and your policy documents in documentation section of Insurance Bazaar App.</p>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="nav-refund" role="tabpanel" aria-labelledby="nav-refund-tab">
            <div class="panel-group" role="tablist" aria-multiselectable="true">
              <div class="container py- py-md-4 py-xl-5">
                <div class="legal-box-title">Refund <span> &#47; Cancellation Policy</span></div>
                <p>Every insurance company has its own cancellation/refund policy by product. Some products offer free look period where customer is entitled to receive complete refund if cancellation is requested within the free look period. On contrary, some products offer prorate refunds if cancelled during the policy time. Note some products are also non- refundable.</p>
                <p>Customer can request cancelation of his policy from policy servicing section of Insurance Bazaar App at any point of time. Cancellation approval will be the decision of the Insurance Company. Insurance Bazaar will facilitate the customers in getting the premium refunds as per Insurance Company’s policies.</p>
                <p>In case of rejection by Visa, you may avail a partial refund of your payment. In such cases, contact us and our team will help you with the process.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Legal',
    data () {
      return {
      }
    },
    components: {
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style scoped>

  /* h1 {
    font-family: "Avenir Medium";
    font-size: 30px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.27;
    letter-spacing: normal;
    text-align: left;
    color: #ba0c2f;
  }
  h4 {
    font-family: "Avenir Medium";
  }
  .data-row:hover {
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
  .data-row p {
    color: #5b6770;
    font-family: "Avenir Book";
  } */
  ul {
    list-style: none;
  }
  li {
    position: relative;
    color:  var(--text-color);
    font-family: "Avenir Book";
  }
  li:before {
    content: "•";
    position: absolute;
    left: -1em;
    color: var(--secondary-color);
  }
  .custom-number li:before {
    content: "";
    position: absolute;
    left: -1em;
    /* color: var(--secondary-color); */
  }
  /* table > tbody > tr,
  .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  table > tbody > tr > th > img,
  .data-img img {
    width: 74px;
    height: 48px;
    border-radius: 7px;
  }
  label {
    position: absolute;
    top: 0;
    right: 1px;
    bottom: 1px;
    left: 0.5em;
    z-index: 1;
    height: 1em;
    font-size: 13px;
    line-height: 3.5em;
    color: #999;
    white-space: nowrap;
    cursor: text;
    transition: all 0.1s ease;
  }
  .input-placeholder:focus ~ label,
  .input-placeholder:valid ~ label {
    font-size: 11px;
    left: 10px;
    top: -10px;
  }
  .input-placeholder:valid ~ label {
    color: green;
  }
  .input-placeholder:focus:invalid ~ label {
    color: red;
  }
  iframe {
    width: 100% !important;
  }
  @media (max-width: 768px) {
    iframe {
      max-height: 250px;
    }
  } */
  .article-box p{
    font-family: "Avenir Book";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: var(--text-color);
  }

/* .ib-acq-navtab .acq-nav-btn {
    width: 12rem !important;
}
@media(max-width:1599px){
   .ib-acq-navtab .acq-nav-btn {
    width: fit-content !important;

    }
} */
.panel-default{
    background-color: rgba(249, 252, 253, 0.7);
    margin-bottom: 28px;
  }
  .panel-body{
    font-family: "Avenir Book";
    font-size: 14px;
    text-align: left;
    color: #787b7c;
    padding: 15px;
  }
  .collapsible-link a{
    margin: 0 0 10px !important;
}

.legal-box-title{
  margin: 10px 0px;
  font-family: "Avenir Medium";
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  color: #ef7c94;
}

.legal-box-title span {
  color: #3d9cbd;
}
</style>



// WEBPACK FOOTER //
// src/views/Legal.vue